const OPERATED = 'operated';
const GRADUAL = 'gradual';
const METRICAL = 'metrical';

const MEAN = 'mean';
const MAX = 'max';
const MIN = 'min';
const MED = 'med';
const STD = 'std';
const Q1 = 'lq';
const Q3 = 'uq';

export default {
  goal: {
    operated: OPERATED,
    gradual: GRADUAL,
    metrical: METRICAL
  },
  metric: {
    mean: MEAN,
    maximum: MAX,
    minimum: MIN,
    median: MED,
    standardDeviation: STD,
    q1: Q1,
    q3: Q3
  }
};



// WEBPACK FOOTER //
// ./src/layouts/variables/aggregateVariableDefs.js